import { useMutation } from '@tanstack/react-query';

import {
  CareerRoleApiResponse,
  RecommendationArticleParams,
} from '@/entities/article';
import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

const fetchTrendingRandomCareerRole = async ({
  year,
  role,
}: RecommendationArticleParams) => {
  const { data } = await clientAxios.get<ApiResponse<CareerRoleApiResponse>>(
    '/trendingRandomCareerRoleApi/',
    {
      params: { year, role },
    }
  );

  const { user_role, user_total_career_year, user_role_kor } = data.data;

  return {
    year: user_total_career_year,
    role: user_role,
    roleKor: user_role_kor,
  };
};

export const useTrendingRandomCareerRole = () => {
  const mutation = useMutation({
    mutationFn: (params: RecommendationArticleParams) =>
      fetchTrendingRandomCareerRole(params),
  });

  return mutation;
};
